require('../modules/esnext.aggregate-error');
require('../modules/esnext.promise.any');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/promise-any.js
// module id = 3281
// module chunks = 1